import { render, staticRenderFns } from "./Loginpopup.vue?vue&type=template&id=04511540&"
import script from "./Loginpopup.vue?vue&type=script&lang=js&"
export * from "./Loginpopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports